module.exports = __webpack_public_path__ + "static/media/YF67_3.66ae38e5.jpg";